import { motion } from "framer-motion";
import { EASE } from "./shared";
import { useLang } from "./i18n";

export function Preloader() {
  const { images } = useLang();
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-midnight"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.65, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="overflow-hidden">
        <motion.div
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="flex items-center gap-4"
        >
          <img
            src={images.logoMark}
            alt="Settld logo"
            className="h-14 w-14 rounded-2xl shadow-[0_8px_28px_rgba(0,0,0,0.4)] sm:h-16 sm:w-16"
          />
          <span className="font-sans text-5xl font-extrabold tracking-tight text-white sm:text-6xl">
            Settld<span className="text-aqua-400">.</span>
          </span>
        </motion.div>
      </div>
    </motion.div>
  );
}
